module.exports = __webpack_public_path__ + "static/img/14043D_8_9_R_20200721_LC.3565170.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/14043D_8_9_R_20200721_LC.png
// module id = Issc
// module chunks = 0